import React from 'react'
import AppBreadcrumb from 'components/layout-components/AppBreadcrumb';
import IntlMessage from '../util-components/IntlMessage';

export const PageHeader = ({ title, display }) => {
	return (
		display ? (
			<>
			<AppBreadcrumb />
			<div className="app-page-header">
				<h1 className="mb-0 mr-3 font-weight-semibold">
					<IntlMessage id={title? title : 'home'}/>
				</h1>
				
			</div>
			</>
		)
		: null
	)
}

export default PageHeader